import { Grid, Typography } from "@mui/material";

import { NodePath } from "domains/nodes/components/node-path";
import localisations from "../../../localisation";

function ConfirmationStage(props: any) {
    const {
        heading,
        blurb,
        sourcePartitionParent,
        sourcePartitionName,
        productName,
        productDescription,
        quantityChange,
        targetPartitionName,
        targetPartitionParent } = localisations.movementAllocation.stages.confirmation;
    const fields = props.fields;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>
            <br />
            <Grid>
                <Typography>{sourcePartitionName}: {fields.sourcePartitionDetails?.name}</Typography>
                <Typography display="inline">{sourcePartitionParent}: </Typography>
                <NodePath
                    textDisplay="inline"
                    showAsText={true}
                    nodeId={fields.sourcePartitionDetails?.partitionParentId}
                />
                <br />
                <br />
                <Typography>{productName}: {fields.productDetails?.sku}</Typography>
                <Typography>{productDescription}: {fields.productDetails?.description}</Typography>
                <Typography>{quantityChange}: {fields.quantityChange}</Typography>
                <br />
                <Typography>{targetPartitionName}: {fields.targetPartitionDetails?.name}</Typography>
                <Typography display="inline">{targetPartitionParent}: </Typography>
                <NodePath
                    textDisplay="inline"
                    showAsText={true}
                    nodeId={fields.targetPartitionDetails?.partitionParentId}
                />
            </Grid>
        </>
    );
}

export default ConfirmationStage;
